import store from 'redux/store'
import { Property, PropertyClient, PropertyValue } from 'api/clients/PropertyClient'
import { handleErrorResponseWithMessage } from 'api/utils/handleErrorResponseWithMessage'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { upsertProperties, upsertProperty, removeProperty } from 'redux/actions/properties'
import { buildErrorMessage } from 'utils'

export const PropertyService = {
  getProperties: async (workspaceKey: string, name: string) => {
    const response = await PropertyClient.getProperties(workspaceKey, { name })
    handleErrorResponseWithMessage(buildErrorMessage(response.data.errors))(response)

    if (response.type === SUCCESS_RESPONSE_TYPE) {
      const {
        data: { properties },
      } = response

      store.dispatch(upsertProperties(properties))
    }

    return response
  },

  createProperty: async (workspaceKey: string, property: Property) => {
    const response = await PropertyClient.createProperty(workspaceKey, property)
    handleErrorResponseWithMessage(buildErrorMessage(response.data.errors))(response)

    if (response.type === SUCCESS_RESPONSE_TYPE) {
      const {
        data: { property },
      } = response

      store.dispatch(upsertProperty(property))
    }

    return response
  },

  updateProperty: async (workspaceKey: string, property: Property, articleId?: string, isUndoAction?: boolean) => {
    const response = await PropertyClient.updateProperty(workspaceKey, property, articleId, isUndoAction)
    handleErrorResponseWithMessage(buildErrorMessage(response.data.errors))(response)

    if (response.type === SUCCESS_RESPONSE_TYPE) {
      const {
        data: { property },
      } = response

      store.dispatch(upsertProperty(property))
    }

    return response
  },

  deleteProperty: async (workspaceKey: string, property: Property) => {
    const response = await PropertyClient.deleteProperty(workspaceKey, property)
    handleErrorResponseWithMessage(buildErrorMessage(response.data.errors))(response)

    if (response.type === SUCCESS_RESPONSE_TYPE) {
      const {
        data: { property },
      } = response

      store.dispatch(removeProperty(property.id))
    }

    return response
  },

  createPropertyValue: async (workspaceKey: string, propertyValue: PropertyValue) => {
    const response = await PropertyClient.createPropertyValue(workspaceKey, propertyValue)
    handleErrorResponseWithMessage(buildErrorMessage(response.data.errors))(response)

    return response
  },

  deletePropertyValue: async (workspaceKey: string, property: Property, propertyValue: PropertyValue) => {
    const response = await PropertyClient.deletePropertyValue(workspaceKey, propertyValue)
    handleErrorResponseWithMessage(buildErrorMessage(response.data.errors))(response)

    store.dispatch(
      upsertProperty({
        ...property,
        property_values: property.property_values.filter(({ id }) => id !== propertyValue.id),
      }),
    )
    return response
  },
}
